import useQueriesRunningInBackGround from 'hooks/useQueriesRunningInBackGround';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { toggleLinearFtForSolarVisibilty } from 'store/slices/ToolSlice';
import SwitchToggle from 'components/Basic/SwitchToggle/SwitchToggle';
import { PanelElement } from '../style';

export default function EdgeLenghtToggle (props: {isB2C?: boolean}) {
	const { showLinearFtForSolar, hideSatelliteOverlay } = useSelector((state: RootState) => state.toolNewPostions.data);
	
	const dispatch = useDispatch<AppDispatch>();
	const queriesRunningInBackGround = useQueriesRunningInBackGround();

	const handleClick = () => {
		dispatch(toggleLinearFtForSolarVisibilty({ visible: !showLinearFtForSolar }));
	};
	
	return (
		<PanelElement style={{ zIndex: 0 , padding: props?.isB2C ? '10px 0 12px': '0', width: props?.isB2C ? 'calc(100% - 0.5rem)': '100%' }}>
			<div className='switchButton showPanel'>
				<span>Show linear feet </span>
				<SwitchToggle 
					checked={showLinearFtForSolar}
					onChange={handleClick}
					disabled={queriesRunningInBackGround || hideSatelliteOverlay}
				/>
			</div>
		</PanelElement>
	);
}
